import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PatientCaseWorkItemFormDataModel} from '../../../../../models/forms/data/patient-case-work-item-form-data.model';
import {StaticDataService} from '../../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../../models/enum/enum-valid-value-item.model';
import {TdoUserConfigurationModel} from '../../../../../models/configuration/user/tdo-user-configuration.model';
import {Globals} from '../../../../../globals';
import {UserService} from '../../../../../services/user.service';

@Component({
  selector: 'app-case-view-patient-forms-details-dialog',
  templateUrl: './case-view-patient-forms-details-dialog.component.html',
  styleUrls: ['./case-view-patient-forms-details-dialog.component.scss']
})
export class CaseViewPatientFormsDetailsDialogComponent implements OnInit {
  enumCaseItemFormStatus: EnumValidValueItemModel[] = [];
  users: TdoUserConfigurationModel[] = [];

  constructor(private dialogRef: MatDialogRef<CaseViewPatientFormsDetailsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public forms: PatientCaseWorkItemFormDataModel[],
              private staticDataService: StaticDataService,
              private globals: Globals,
              private userService: UserService) {
    for (const form of forms) {
      form.Versions = form.Versions.sort((a, b) => {
        return a.Version - b.Version;
      });
    }

    this.userService.getAllUsers(this.globals.TDOCID).subscribe((users) => {
      this.users = users;
    });
  }

  ngOnInit(): void {
    this.enumCaseItemFormStatus = this.staticDataService.getValidValueItemsByValidValueName('enumFormCompletionStatus');
  }

  onOkClick() {
    this.dialogRef.close();
  }

  getUserName(userId: string): string {
    if (!userId?.trim()) {
      return '';
    }
    const user = this.users.find(user => user.UserID?.toLowerCase() === userId.toLowerCase());
    return user ? `${user.FirstName} ${user.LastName}` : '';
  }
}
